export async function initiateApp(opts = {}) {
  const { initiateRoutes } = await import('@/core/router');
  const { initiateEvents } = await import('@/core/events');
  const { initiateStore } = await import('@/core/store');

  await initiateEvents(opts);
  await initiateRoutes(opts);
  await initiateStore(opts);
}
